import React from "react";
import { Button } from "antd";
import styled from "styled-components";
import { Box } from "reflexbox/styled-components";
import { withLocalizeStrings } from "../../../languages/Localize";

const StyledMountainButton = styled(Button)`
    width: 100%;
    height: 100%;
    background-color: ${({ theme }) => theme.colors.white};
    text-align: center;
    border: none;
    border-radius: 15px;
    margin-top: 4vh;
    color: ${({ theme }) => theme.colors.primary};
    font-weight: ${({ theme }) => theme.fontWeights.bold};
    font-size: ${({ theme }) => theme.fontSizes[4]}px;
    &:hover,
    &:focus {
        background-color: ${({ theme }) => theme.colors.white};
        color: ${({ theme }) => theme.colors.primary};
        outline: none;
    }
`;

const SignUpButton = ({ strings, path }) => {
    return (
        <Box marginX={[3, 4]}>
            <StyledMountainButton>
                <a href={path}>{strings.home.SIGN_UP}</a>
            </StyledMountainButton>
        </Box>
    );
};

export default withLocalizeStrings(SignUpButton);
